import {Component, OnDestroy, OnInit} from '@angular/core';
import {Location} from '@angular/common';
import {ASecureForm} from '../../../sdk/interface/form/ASecureForm';
import {ActivatedRoute, Router} from '@angular/router';
import {AlertService} from '../../../sdk/service/alert.service';
import {Account, AccountLog, AccountType, WebAccountService} from 'web-angular-client';
import {AuthenticationService} from '../../../sdk/service/authentication.service';
import {AccountStatusUtil} from '../../../sdk/interface/accountStatusUtil';
import {EnvironmentService} from '../../../sdk/service/environment.service';

@Component({
    selector: 'app-payment-request-view',
    templateUrl: './payment-request-view.component.html',
    styleUrls: ['./payment-request-view.component.scss'],
    standalone: false
})
export class PaymentRequestViewComponent extends ASecureForm implements OnInit, OnDestroy
{
    account: Account;
    accountLogs: AccountLog [];
    interval: any;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        protected authenticationService: AuthenticationService,
        protected environmentService: EnvironmentService,
        private alertService: AlertService,
        private location: Location,
        private webAccountService: WebAccountService,
        protected accountStatusUtil: AccountStatusUtil)
    {
        super(authenticationService, environmentService);
    }

    ngOnInit()
    {
        this.route.params.subscribe(params =>
        {
            const paymentId = params['id'];

            this.loadPayment(paymentId);
            this.loadPaymentAuditLog(paymentId);
        });

        this.interval = setInterval(() =>
        {
            this.loadPayment(this.account.id);
            this.loadPaymentAuditLog(this.account.id);
        }, 5000);
    }

    ngOnDestroy(): void
    {
        clearInterval(this.interval);
    }

    edit()
    {
        this.router.navigate([this.routes.SECURE.ACCOUNT.EDIT.pathSansParameters, this.account.id]).then();
    }

    back()
    {
        this.location.back();
    }

    isEcommerceAccount(): boolean
    {
        return this.account?.accountType === AccountType.ECOMMERCE_RTP;
    }

    public getAccountStatusUtil(): AccountStatusUtil
    {
        return this.accountStatusUtil;
    }

    getAmount(account: Account): number
    {
        return !!account?.dateTimePaid ? account?.amountPaid : account?.amount;
    }

    private loadPayment(id: number)
    {
        this.debugOutput('Load Account ID ' + id);
        this.webAccountService.getAccountById(id).subscribe({
            next: account =>
            {
                this.account = account;
            },
            error: error =>
            {
                this.alertService.error(error, true);
                this.router.navigate([this.routes.SECURE.ACCOUNT.LIST.path]).then();
            }
        });
    }

    private loadPaymentAuditLog(id: number)
    {
        this.webAccountService.getAccountLogsByAccountId(id).subscribe({
            next: logs =>
            {
                this.accountLogs = logs;
            },
            error: error =>
            {
                this.alertService.error(error, true);
                this.router.navigate([this.routes.SECURE.ACCOUNT.LIST.path]).then();
            }
        });
    }
}